import { Link } from 'react-router';

import { SuccessIcon } from '@workspace/ui';

import { AuthShell } from '../../components/auth-shell.tsx';

export default function ResetPasswordEmailSent() {
  return (
    <AuthShell title="Check your inbox">
      <div className="mt-6 flex flex-col items-center gap-4 text-center">
        <SuccessIcon />
        <p className="text-muted-foreground text-sm">
          If that email is registered, we have sent it a link to reset your
          password. The link expires in one hour.
        </p>
        <Link to="/signin" className="text-primary text-sm font-medium">
          Back to sign in
        </Link>
      </div>
    </AuthShell>
  );
}
